import script from "./AppPermissionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPermissionsList.vue?vue&type=script&setup=true&lang=js"

import "./AppPermissionsList.vue?vue&type=style&index=0&id=10e3da4e&lang=css"

const __exports__ = script;

export default __exports__